import * as React from 'react';
import { Range, getTrackBackground } from 'react-range';

const STEP = 1;
const COLORS = ['#2570a747', '#EA611D', '#EA611D', '#EA611D', '#EA611D', '#ccc'];


const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
});

class DiscoutRange extends React.Component {
  state = {
    values: this.props.range,
    onChange: this.props.onChange
  };
  render() {
    return (
      <div
        className='discount-range'
      >
        <Range
          values={this.state.values}
          step={STEP}
          min={this.props.MIN}
          max={this.props.MAX}
          onChange={values => {
            if (values[0] < values[1] - 2) {
              this.setState({ values })
              this.props.onChange(values)
            }
          }
          }
          renderTrack={({ props, children }) => (
            <div
              onMouseDown={props.onMouseDown}
              onTouchStart={props.onTouchStart}
              style={{
                ...props.style,
                height: '36px',
                display: 'flex',
                width: '100%'
              }}
            >
              <div
                className='discountRangeSlider'
                ref={props.ref}
                style={{
                  height: '5px',
                  width: '100%',
                  borderRadius: '4px',
                  background: getTrackBackground({
                    values: this.state.values,
                    colors: COLORS,
                    min: this.props.MIN,
                    max: this.props.MAX
                  }),
                  alignSelf: 'center'
                }}
              >
                {children}
              </div>
            </div>
          )}
          renderThumb={({ props, index, isDragged }) => (
            <div
              className={`discount-range-box ${index === 0 ? 'thumb-1' : 'thumb-2'} ${isDragged ? 'dragged' : ''
                }`}
              {...props}
              style={{
                ...props.style,
                height: '12px',
                width: '30px',
                borderRadius: '4px',
                backgroundColor: index === 0 ? '#667CC2' : '#DC6B33',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <div className={`range-price  ${index === 0 ? 'thumb-1' : 'thumb-2'} ${isDragged ? 'dragged' : ''
                }`}>
                {formatter.format(this.state.values[index])}
              </div>
              <div
                style={{
                  height: '16px',
                  width: '5px',

                }}
              />
            </div>
          )}
        />
      </div>
    );
  }
}

export default DiscoutRange;